import moment from "moment";
import { defaultMemoize } from "reselect";

export type TimeWindowType = {
  start: moment.Moment | null | undefined;
  end: moment.Moment | null | undefined;
};

export type OptionType = {
  label: string;
  value: TimeWindowType;
  key: "past" | "upcoming" | "overdue" | AssignmentListFilter;
};

export const assignmentsOverviewFilters = {
  upcoming: {
    label: "Upcoming",
    value: "upcoming"
  },
  overdue: {
    label: "Overdue",
    value: "overdue"
  },
  past: {
    label: "Past",
    value: "past"
  }
};

export enum AssignmentListFilter {
  todo = "todo",
  done = "done",
  missed = "missed"
}

export const assignmentsListFilters = {
  [AssignmentListFilter.todo]: {
    label: "To do",
    value: "todo"
  },
  [AssignmentListFilter.done]: {
    label: "Done",
    value: "done"
  },
  [AssignmentListFilter.missed]: {
    label: "Missed",
    value: "missed"
  }
};

export const defaultFilterState = assignmentsOverviewFilters.upcoming.value;

export const getTeacherToggleOptions = defaultMemoize(
  (now: moment.Moment): Array<OptionType> => [
    {
      label: assignmentsOverviewFilters.upcoming.label,
      key: assignmentsOverviewFilters.upcoming.value as "upcoming",
      value: {
        start: now,
        end: null
      }
    },
    {
      label: assignmentsOverviewFilters.past.label,
      key: assignmentsOverviewFilters.past.value as "past",
      value: {
        start: null,
        end: now
      }
    }
  ]
);

export const studentToggleOptions = [
  {
    label: assignmentsListFilters[AssignmentListFilter.todo].label,
    key: assignmentsListFilters[AssignmentListFilter.todo].value
  },
  {
    label: assignmentsListFilters[AssignmentListFilter.done].label,
    key: assignmentsListFilters[AssignmentListFilter.done].value
  },
  {
    label: assignmentsListFilters[AssignmentListFilter.missed].label,
    key: assignmentsListFilters[AssignmentListFilter.missed].value
  }
];

export const defaultToggleOption = {
  label: assignmentsListFilters[AssignmentListFilter.todo].label,
  key: assignmentsListFilters[AssignmentListFilter.todo].value
};

export const STATUS_CODES = {
  missed: -2,
  late: -1,
  inProgress: 0,
  completed: 1,
  notStarted: 2
};

export enum ScoreStatus {
  NotAttempted = -1,
  NotSet = -2
}
